import { For } from 'solid-js';
import { categories } from '~/data/categories';
import { CategoryIcon } from '~/components/CategoryIcon';
import './Supplies.css';

interface Props {
  onRequestClick?: () => void;
}

export function Supplies(props: Props) {
  return (
    <section class="section supplies" id="supplies">
      <div class="container">
        <div class="section-head section-head--compact" data-reveal>
          <div class="eyebrow">Что поставляем</div>
          <p class="section-head__lead">
            Закрываем потребность в агрегатах и компонентах для грузовой, специальной и промышленной техники —
            и работаем с позициями, которые сложно найти у большинства российских поставщиков.
          </p>
        </div>

        <div class="supplies__grid">
          <For each={categories}>
            {(category, i) => (
              <article class="supply" data-reveal style={`--delay:${i() * 60}ms`}>
                <div class="supply__icon" aria-hidden="true">
                  <CategoryIcon icon={category.icon} />
                </div>
                <h3 class="supply__title">{category.title}</h3>
                <p class="supply__desc">{category.description}</p>
              </article>
            )}
          </For>
        </div>

        <div class="supplies__cta" data-reveal>
          <button class="btn btn--primary" onClick={props.onRequestClick}>
            Найти нужную запчасть <span class="btn__arrow">→</span>
          </button>
        </div>
      </div>
    </section>
  );
}
